import { convertDXFToGeoJSON } from "../dxfConverter.js";
import { normalizeGeoJsonProperties } from "../importTools.js";

export async function dxfToGeojsonConverter(file) {
  if (!file) return { geojson: null, errors: ["No file provided."] };

  const raw = await convertDXFToGeoJSON(file);
  const geojson = normalizeGeoJsonProperties(raw);

  const layersSet = new Set();
  for (const feature of geojson?.features || []) {
    const layer = feature?.properties?.layer;
    if (layer) layersSet.add(layer);
  }
  const uniqueLayers = Array.from(layersSet).sort();

  const layerMapping = {};
  for (const layer of uniqueLayers) {
    const layerLower = String(layer || "").toLowerCase().trim();
    // Be strict: avoid ignoring legit layers like "cartouche_points" by accident.
    // Only ignore obvious title-block layers.
    const normalized = layerLower.replace(/[^a-z0-9]+/g, " ").trim();
    const ignored =
      normalized === "cartouche" ||
      normalized === "cadre" ||
      normalized === "titleblock" ||
      normalized === "title block";
    layerMapping[layer] = { keyId: "", optionId: "", comment: "", ignored };
  }

  const geomStats = (geojson?.features || []).reduce(
    (acc, f) => {
      const t = (f?.geometry && f.geometry.type) || "";
      if (t === "Point" || t === "Circle") acc.point += 1;
      else if (t === "LineString" || t === "MultiLineString") {
        if (f?.properties && f.properties.closed === true) acc.polygon += 1;
        else acc.line += 1;
      } else if (t === "Polygon" || t === "MultiPolygon") acc.polygon += 1;
      else acc.other += 1;
      return acc;
    },
    { point: 0, line: 0, polygon: 0, other: 0 },
  );

  return {
    geojson,
    errors: [],
    dxfRawGeoJSON: geojson,
    uniqueLayers,
    layerMapping,
    geomStats,
  };
}

